import React from 'react';
import { openUrl, eventGuideData, convertDataToUrl, convertTitleToUrl, URL, filter_media } from './Common';
import RatingsSelect from './RatingsSelect';
import { NavLink } from "react-router-dom";
import EraIcon from './EraIcon';
import CommentSection from './CommentSection';
import MarkAsReadSelect from './MarkAsReadSelect';


class MediaPage extends React.Component {
  constructor(props) {
    super(props);
  }

  getDataIndex(rawData) {
    const view = window.location.href.split('/').at(-1);

    if (!rawData) {
      return -1;
    }

    let dataIndex = rawData.findIndex(x => convertDataToUrl(x) === view.toLowerCase());
    if (dataIndex < 0) {
      // if the click on the season of a show, return the first episode
      dataIndex = rawData.findIndex(x => x.format === 'T' && convertTitleToUrl(x.collection_title) === view.toLowerCase());
      if (dataIndex < 0) {
        // check if the show was referencing by episode number instead of by title
        dataIndex = rawData.findIndex(x => x.format === 'T' && convertTitleToUrl(`${x.title.split(':')?.[0]}: ${x.subtitle}`) === view.toLowerCase());
      }
    }

    if (dataIndex < 0) {
      return -1;
    }
    else {
      return dataIndex;
    }
  }

  componentDidMount() {
    this.setState({ data: null });
  }

  render() {
    const view = window.location.href.split('/').at(-1);

    if (!this.props.data || !view) {
      return null;
    }

    const rawData = filter_media(this.props.data.sort((a, b) => a?.sort_order - b?.sort_order), ['collectionFilter']);
    const dataIndex = this.getDataIndex(rawData);

    const data = rawData[dataIndex];
    const prevData = rawData[dataIndex - 1];
    const nextData = rawData[dataIndex + 1];

    let eventGuidePath;
    Object.entries(eventGuideData).map(([path, guideData]) => {
      if (this.props.data?.collection_title?.includes(guideData.title)) {
        eventGuidePath = path;
      }
    });

    return (
      <div className="blog-inner">
        <div className="infopanel-inner header-box">
          <div>
            <div className="title">{data?.title}</div>
            <div>{data?.subtitle}</div>
            <RatingsSelect
              data={data}
              loggedIn={this.props.loggedIn}
              addRating={this.props.addRating}
            />
            <MarkAsReadSelect 
              data={data}
              loggedIn={this.props.loggedIn}
              addRating={this.props.addRating}
            />
            <div>
              {
                data?.release_date
                  ? `Release date: ${new Date(data?.release_date).toISOString().slice(0, 10)}`
                  : 'Not yet released'
              }
            </div>
          </div>
          <EraIcon data={data} className="hide-mobile"/>
        </div>
        <div className="infopanel-inner blog-body">
          <div className="image">
            <img
              src={`/img/${data?.img || 'blank'}.png`}
              style={{ height: '100%' }}
              alt={`Cover art of ${data?.title}`}
            />
            {
              data?.amazon
                ? <button
                  onClick={() => openUrl(data.amazon)}
                >View on Amazon</button>
                : <div />
            }
          </div>
          <div>
            <div className="title">Plot Summary</div>
            <p>{data?.summary || 'Plot summary coming soon...'}</p>
            <p>{data?.collected_issues}</p>
            {
              data?.notes
                ? <div><div className="title">Timeline Placement Notes</div><p>{data?.notes}</p></div>
                : <div />
            }
            {
              eventGuidePath
                ? <NavLink
                  to={`/${eventGuidePath}`}
                >
                  <button>View Event Guide</button>
                </NavLink>
                : <div />
            }
          </div>
        </div>
        <div className="infopanel-inner blog-body header-box">
          {
            prevData
              ?
              <NavLink
                className="content-suggestion"
                to={`/content/${convertDataToUrl(prevData)}`}
              >
                <div style={{ display: 'flex', width: '300px', padding: '10px', textAlign: 'start', justifyContent: 'start' }}>
                  <img
                    src={`/img/${prevData?.img || 'blank'}.png`}
                    style={{ height: '100px', margin: '10px' }}
                    alt={`Cover art of ${data?.title}`}
                  />
                  <div>
                    <div className="title">Previous in timeline:</div>
                    <p>{`${prevData.title}`}</p>
                  </div>
                </div>

              </NavLink>
              : <p />
          }
          {
            nextData
              ?
              <NavLink
                className="content-suggestion"
                to={`/content/${convertDataToUrl(nextData)}`}
                style={{ justifyContent: 'end' }}
              >
                <div style={{ display: 'flex', width: '300px', padding: '10px', textAlign: 'end', justifyContent: 'end' }}>
                  <div>
                    <div className="title">Next in timeline:</div>
                    <p>{`${nextData.title}`}</p>
                  </div>
                  <img
                    src={`/img/${nextData?.img || 'blank'}.png`}
                    style={{ height: '100px', margin: '10px' }}
                    alt={`Cover art of ${data?.title}`}
                  />
                </div>
              </NavLink>
              : <p />
          }
        </div>
        <div className='infopanel-inner'>
        <CommentSection
          loggedIn={this.props.loggedIn}
          data={data}
          username={this.props.username}
          profileImg={this.props.profileImg}
        />
        </div>
      </div>
    );
  }
}

export default MediaPage;
